import {YesNoFormValue, type TakeFiveSafetyStepFormValues} from '../../../types'

export const safetyDefaultValues: TakeFiveSafetyStepFormValues = {
  peopleInformed: {value: YesNoFormValue.YES, comment: ''},
  rightTools: {value: YesNoFormValue.YES, comment: ''},
  fitForDuty: {value: YesNoFormValue.YES, comment: ''},
  riskRecognized: {value: YesNoFormValue.YES, comment: ''},
  reasonToWorkSafe: '',
  supervisor: null
}
